import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClientEmployeeRelationshipComponent } from './client-employee-relationship.component';

const routes: Routes = [ { path: '', component: ClientEmployeeRelationshipComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientEmployeeRelationshipRoutingModule { }
